/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'cancel': {
    viewBox: '0 0 32 32',
    data: '<path d="M16,1C7.7,1,1,7.7,1,16c0,8.3,6.7,15,15,15c8.3,0,15-6.7,15-15C31,7.7,24.3,1,16,1z M21.7,20.3c0.4,0.4,0.4,1,0,1.4 C21.5,21.9,21.3,22,21,22s-0.5-0.1-0.7-0.3L16,17.4l-4.3,4.3C11.5,21.9,11.3,22,11,22s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4 l4.3-4.3l-4.3-4.3c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l4.3,4.3l4.3-4.3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L17.4,16L21.7,20.3z"/>'
  }
})
